module.exports = __webpack_public_path__ + "r-v3/img/ml_07_00.ce2c0c67.jpg";